import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import { useTranslation } from 'react-i18next';

const PaymentRes = () => {
    const { t } = useTranslation();
    const { setPaymentRes, handleCallApi } = useContext(MyContext);

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const status = searchParams.get("status");
    const transactionId = searchParams.get("transactionId") || "N/A";
    const orderId = searchParams.get("order_id");
    const transactionStatus = searchParams.get("transaction_status");
    const statusCode = searchParams.get("status_code");

    const targetPage = secureLocalStorage.getItem("Page") || "/";

    const [countdown, setCountdown] = useState(5);
    const DataRef = useRef(false);

    const isSuccess = status === "true" || transactionStatus === "capture" || transactionStatus === "settlement" || statusCode === "200";
    const resolvedTxId = transactionId !== "N/A" ? transactionId : (orderId || "N/A");

    useEffect(() => {
        if (DataRef.current) return;
        DataRef.current = true;

        if (isSuccess) {
            setPaymentRes("PaymentDone");
            secureLocalStorage.setItem("transactionid", resolvedTxId);
            
            // Background verification request for Midtrans direct redirects
            if (orderId && (transactionStatus || statusCode)) {
                const Userid = secureLocalStorage.getItem("Userid");
                const paymentData = secureLocalStorage.getItem("paymentData");
                let amount = "0";
                if (paymentData) {
                    try {
                        const parsed = JSON.parse(paymentData);
                        amount = parsed.amount || "0";
                    } catch (e) {
                        console.error(e);
                    }
                }
                handleCallApi("Get", `payment/midtrans-success?order_id=${orderId}&uid=${Userid}&amount=${amount}`)
                    .then(res => {
                        console.log("Midtrans payment verified successfully on backend:", res);
                    }).catch(err => {
                        console.error("Error verifying Midtrans payment:", err);
                    });
            }
        } else {
            setPaymentRes("PaymentFaild");
        }
    }, [status, isSuccess, resolvedTxId, orderId, transactionStatus, statusCode]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    navigate(targetPage);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [targetPage]);

    return (
        <div className="min-h-[70vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
            <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-2xl shadow border border-gray-150 text-center">
                {isSuccess ? (
                    <div>
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 text-green-600 mb-6">
                            <svg className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h2 className="text-3xl font-extrabold text-gray-900 mb-2">{t("Payment Success!")}</h2>
                        <p className="text-gray-600 mb-6">
                            {t("Thank you! Your transaction has been successfully processed.")}
                        </p>
                    </div>
                ) : (
                    <div>
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 text-red-600 mb-6">
                            <svg className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h2 className="text-3xl font-extrabold text-gray-900 mb-2">{t("Payment Failed")}</h2>
                        <p className="text-gray-600 mb-6">
                            {t("Oops! We could not process your transaction. Please try again.")}
                        </p>
                    </div>
                )}

                <div className="bg-gray-50 rounded-xl p-4 mb-6 border border-gray-100 text-sm text-gray-650 space-y-2 text-left">
                    <div className="flex justify-between">
                        <span className="font-semibold text-gray-500">{t("Transaction ID")}:</span>
                        <span className="font-mono text-gray-900 break-all">{transactionId}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-gray-500">{t("Status")}:</span>
                        <span className={`font-bold ${isSuccess ? 'text-green-600' : 'text-red-600'}`}>
                            {isSuccess ? t("SUCCESS") : t("FAILED")}
                        </span>
                    </div>
                </div>

                <p className="text-xs text-gray-400 mb-6">
                    {t("Redirecting you automatically in {{seconds}} seconds...", { seconds: countdown })}
                </p>

                <div className="flex flex-col gap-3">
                    <button
                        onClick={() => navigate(targetPage)}
                        className={`w-full py-2.5 rounded-xl font-bold italic tracking-[1px] text-white shadow transition-all active:scale-[0.98] ${
                            isSuccess ? 'bg-[--bg-color] hover:opacity-95' : 'bg-orange-500 hover:opacity-95'
                        }`}
                    >
                        {isSuccess ? t("Proceed") : t("Retry Payment")}
                    </button>
                    <button
                        onClick={() => navigate("/")}
                        className="w-full py-2.5 rounded-xl font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200 active:scale-[0.98] transition-colors"
                    >
                        {t("Go Home")}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PaymentRes